import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=4853d0e3&scoped=true&"
import script from "./TextEditor.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TextEditor.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=4853d0e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853d0e3",
  null
  
)

export default component.exports